import React, {useState, useContext, useMemo, useEffect} from 'react'
import {Typography, Grid} from '@material-ui/core'
import moment from 'moment'
import SearchItem from '../SearchItem'
import SelectedItems from '../SelectedItems'
import {ReservationContext} from '../../../context/Reservation/Reservation'
import ReservedForOptions from '../CustomComponents/ReservedForOptions'
import {transformDateFormat, transformTimeFormat} from '../../../context/Reservation/util'
import './StepSelectItem.scss'

const StepSelectItem = ({date_format, time_format, showDate = false}) => {
  const ctxReservation = useContext(ReservationContext)
  const {reservations, clearReservationsData} = useContext(ReservationContext)

  const {formatSelectedItems, reservation, update} = ctxReservation
  const {selected_items} = reservation

  const handleRemove = (e, item) => {
    const _selected_items = [...selected_items]
    const index = _selected_items.findIndex((s, i) => s.id === item.id)
    if (index !== -1) {
      _selected_items.splice(index, 1)
    }
    update('selected_items', _selected_items)
  }

  useEffect(() => {
    if (reservations.data) {
      clearReservationsData()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <section>
        <Typography className="ap-typography ap-typography--lg">Select Reserved For</Typography>
        <Grid container style={{marginTop: 16}}>
          <ReservedForOptions />
          {showDate && (
            <>
              <div className="ap-box" style={{marginLeft: 20}}>
                <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
                  From
                </Typography>
                <Typography className="ap-typography ap-typography--sm">
                  {moment(ctxReservation.reservation.date_from).format(
                    `${date_format} ${time_format}`
                  )}
                </Typography>
              </div>
              <div className="ap-box" style={{marginLeft: 14}}>
                <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
                  To
                </Typography>
                <Typography className="ap-typography ap-typography--sm">
                  {moment(ctxReservation.reservation.date_to).format(
                    `${date_format} ${time_format}`
                  )}
                </Typography>
              </div>
            </>
          )}
        </Grid>
      </section>
      <section
        style={{marginTop: 22}}
        className={ctxReservation.reservation.reserved_for.name ? '' : 'disable-items'}
      >
        <Typography className="ap-typography ap-typography--lg">Select Items</Typography>
        <Grid container style={{marginTop: 0}} spacing={2}>
          <Grid item style={{flex: 1, maxWidth: 715}}>
            <SearchItem />
          </Grid>
          <Grid item style={{width: 192, paddingRight: '2px'}}>
            <SelectedItems items={formatSelectedItems} onRemove={handleRemove} />
          </Grid>
        </Grid>
      </section>
    </>
  )
}

export default StepSelectItem
